export class VehicleVersion {
    versionCode: number;
    versionDescription?: string;
    infoAutoCode?: number;
    price?: number;

    constructor(data?: VehicleVersion) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
